/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRatioResponse
 */
export interface AdminRatioResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminRatioResponse
     */
    numerator: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRatioResponse
     */
    denominator: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRatioResponse
     */
    fraction: number;
}

/**
 * Check if a given object implements the AdminRatioResponse interface.
 */
export function instanceOfAdminRatioResponse(value: object): value is AdminRatioResponse {
    if (!('numerator' in value) || value['numerator'] === undefined) return false;
    if (!('denominator' in value) || value['denominator'] === undefined) return false;
    if (!('fraction' in value) || value['fraction'] === undefined) return false;
    return true;
}

export function AdminRatioResponseFromJSON(json: any): AdminRatioResponse {
    return AdminRatioResponseFromJSONTyped(json, false);
}

export function AdminRatioResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRatioResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'numerator': json['numerator'],
        'denominator': json['denominator'],
        'fraction': json['fraction'],
    };
}

export function AdminRatioResponseToJSON(value?: AdminRatioResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numerator': value['numerator'],
        'denominator': value['denominator'],
        'fraction': value['fraction'],
    };
}

